import { Button, Modal } from '@loomhq/lens';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import SalesforceAddEmail from '../salesforce-add-email';
import SalesforceDeleteEmail from '../salesforce-delete-email';
import { updateSalesforceModal } from '../../../../actions/shareVideo';
import { deleteShareVideoAlias } from '../../../../creators/shareVideo';

import styles from './styles.module.less';

const SalesforceModal = ({ showModal }) => {
  const dispatch = useDispatch();
  const [deletedAlias, setDeletedAlias] = useState(null);

  const { shareVideoAliases } = useSelector(state => state.share_video);

  const deleteLinkHandler = alias => setDeletedAlias(alias);

  const removeFromList = () => {
    if (deletedAlias) {
      dispatch(deleteShareVideoAlias(deletedAlias.id));
      setDeletedAlias(null);
    }
  };

  const closeModal = () => dispatch(updateSalesforceModal(false));

  return (
    <Modal
      title={
        deletedAlias
          ? 'Are you sure you want to delete this contact?'
          : 'Salesforce'
      }
      className={styles.sfdcModal}
      isOpen={showModal}
      onCloseClick={() => closeModal()}
      onBackgroundClick={() => closeModal()}
      alternativeButton={
        deletedAlias && (
          <Button onClick={() => setDeletedAlias(null)}>Back</Button>
        )
      }
      mainButton={
        deletedAlias ? (
          <Button variant="primary" onClick={() => removeFromList()}>
            Yes, delete contact
          </Button>
        ) : shareVideoAliases.length > 0 ? (
          <Button variant="primary" onClick={() => closeModal()}>
            Done
          </Button>
        ) : null
      }
    >
      {deletedAlias ? (
        <SalesforceDeleteEmail email={deletedAlias.email} />
      ) : (
        <SalesforceAddEmail deleteLinkHandler={deleteLinkHandler.bind(this)} />
      )}
    </Modal>
  );
};

export default SalesforceModal;
